export default "__VITE_ASSET__BGNIQIsq__"